import React, { FC } from 'react'
import { Typography } from '@material-ui/core'

interface FormDataProps {
  formData: any
}

export const AsidePreview: FC<FormDataProps> = ({ formData }) => {
  return (
    <div style={{ margin: '1em' }}>
      <Typography variant="h6">Dados Inseridos</Typography>
      {formData && (
        <>
          <Typography variant="body2">
            Creation type: {formData?.type}
          </Typography>
          <Typography variant="body2">
            Creation released_at: {formData?.released_at}
          </Typography>
          <Typography variant="body2">
            Creation slug: {formData?.slug}
          </Typography>
          <Typography variant="body2">
            Creation order: {formData?.order}
          </Typography>
          <Typography variant="body2">
            Creation subtitle: {formData?.subtitle}
          </Typography>
          <Typography variant="body2">
            Creation title: {formData?.title}
          </Typography>
          <Typography variant="body2">
            Creation type: {formData?.type}
          </Typography>
        </>
      )}
    </div>
  )
}
